import GoogleAd from './GoogleAd';
export default GoogleAd;
